import { on } from 'delegated-events'

on('tablist:tabshow', 'html', (e) => {
  const tab = e.detail.panelEl
  const index = tab.dataset.index
  const element = tab.closest('.element-section')
  const panelMedia = element.querySelectorAll('.panel-media')

  if (panelMedia.length) {
    panelMedia.forEach((x) => x.classList.add('hidden'))

    element.querySelector(`.panel-media[data-index="${index}"]`).classList.remove('hidden')
  }
})
